import React from "react";
import { Dropdown, MenuItem, DropdownButton } from "react-bootstrap";
import CustomToggle from "../../../../Themes/DropDown/CustomToggle";

import Pagination from "../../../HSGPagination/HSGPagination";
import EpisodeCard from "./EpisodeCard";

import "../SmartClinic.css";
import "./Episode.css";

const episodeSort = [
    { img: "A-Z", span: "Episode Date" },
    { img: "Z-A", span: "Episode Date" }
    // { img: 'A-Z', span: 'Criticality' },
    // { img: 'Z-A', span: 'Criticality' }
];

const episodeAilment = {
    Obese: "obese",
    "Under Weight": "underweight",
    Normal: "normal",
    "Over Weight": "overweight",
    "Vision Normal": "eyeNormal",
    "Vision Abnormal": "eyeAbnormal"
};

const episodeSortMeta = {
    "1": { sortOrder: "desc", sortField: "modified_time" },
    "2": { sortOrder: "asc", sortField: "modified_time" },
    "3": { sortOrder: "desc", sortField: "modified_time" },
    "4": { sortOrder: "desc", sortField: "modified_time" },
    default: { sortOrder: "desc", sortField: "modified_time" }
};

function getKeyByValue(object, value) {
    return Object.keys(object).find(key => object[key] === value);
}

class EpisodeList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTab: 0,
            inSearchString: "",

            defaultLimit: 5,
            defaultOffset: 0,
            defaultSortField: "modified_time",
            defaultSortBy: "desc",
            defaultSearchString: "",

            selectedClass: null,
            selectedSection: null,
            selectedAilment: null
        };
    }

    componentWillMount() {
        this.props.getSchoolClasses && this.props.getSchoolClasses();
        this.props.fetchEpisodeSearch(
            this.props.buildEpisodeHeader(
                {
                    inOrganizationId: this.props.organizationId,
                    inStudentId: this.props.studentId,
                    inLimit: this.state.defaultLimit,
                    inOffset: this.state.defaultOffset,
                    inSortBy: this.state.defaultSortBy,
                    inSortField: this.state.defaultSortField
                },
                this.props.episodeHeader
            )
        );
    }

    componentDidMount() {}

    componentWillReceiveProps(nextProps) {}

    showNext = where => {
        let { inLimit, inOffset } = this.props.episodeHeader;
        let { episodeTotal, episodeHeader } = this.props;
        if (where === "prev") {
            let newOffset = inOffset - inLimit < 0 ? 0 : inOffset - inLimit;
            this.props.fetchEpisodeSearch(this.props.buildEpisodeHeader({ inOffset: newOffset }, episodeHeader));
        } else {
            if (inOffset >= episodeTotal || inOffset + inLimit >= episodeTotal) {
                return;
            }
            let newOffset = inOffset + inLimit;
            this.props.fetchEpisodeSearch(this.props.buildEpisodeHeader({ inOffset: newOffset }, episodeHeader));
        }
    };

    _renderPagination = className => {
        const { episodeHeader, episodeList, episodeTotal } = this.props;
        return episodeList && episodeList.length ? (
            <Pagination
                inOffset={episodeHeader.inOffset}
                showNext={this.showNext}
                data={episodeList}
                total={episodeTotal}
                className={className}
            />
        ) : null;
    };

    search(param) {
        let inSearchString = param;
        this.props.fetchEpisodeSearch(
            this.props.buildEpisodeHeader(
                {
                    inSearchString: inSearchString,
                    inLimit: this.state.defaultLimit,
                    inOffset: this.state.defaultOffset
                },
                this.props.episodeHeader
            )
        );
    }

    searchEpisode = e => {
        const { inSearchString } = this.state;
        e.keyCode === 13 && this.search(inSearchString.trim().toLowerCase());
    };

    updateSearchBox = e => {
        e.target.value !== this.state.inSearchString && this.setState({ inSearchString: e.target.value });
    };

    onSelectMenuItem = e => {
        let sortBy, sortField;

        if (e === null || e === undefined || parseInt(e) > 4) {
            e = "default";
        }
        sortBy = episodeSortMeta[e].sortOrder;
        sortField = episodeSortMeta[e].sortField;

        this.props.fetchEpisodeSearch(
            this.props.buildEpisodeHeader(
                {
                    inSortField: sortField,
                    inSortBy: sortBy,
                    inLimit: this.state.defaultLimit,
                    inOffset: this.state.defaultOffset
                },
                this.props.episodeHeader
            )
        );
    };

    onSelectAilmentItem = e => {
        if (e === null || e === undefined || parseInt(e) > 6) {
            e = "";
        }

        this.props.fetchEpisodeSearch(
            this.props.buildEpisodeHeader(
                {
                    inAilment: e,
                    inLimit: this.state.defaultLimit,
                    inOffset: this.state.defaultOffset
                },
                this.props.episodeHeader
            )
        );
    };

    _renderSortOptions = () => (
        <Dropdown id="dropdown-custom-menu-episode-sort" className="sort-dropdown">
            <CustomToggle bsRole="toggle" className="sort-label">
                <span aria-hidden="true" data-icon="&#e900;" className="icon-sort"></span>
                <span>Sort</span>
            </CustomToggle>

            <Dropdown.Menu bsRole="menu" className="select-sort">
                {episodeSort.map((m, i) => {
                    return (
                        <MenuItem key={i.toString()} eventKey={i + 1} onSelect={this.onSelectMenuItem}>
                            <span className="sort-item-img">{m.img}</span>
                            <span className="sort-item">{m.span}</span>
                        </MenuItem>
                    );
                })}
            </Dropdown.Menu>
        </Dropdown>
    );

    _renderAilmentOptions = () => (
        <Dropdown id="dropdown-custom-menu-episode-sort" className="sort-dropdown">
            <CustomToggle bsRole="toggle" className="sort-label">
                <span aria-hidden="true" data-icon="&#e900;" className="icon-sort"></span>
                <span>Ailment</span>
            </CustomToggle>

            <Dropdown.Menu bsRole="menu" className="select-sort">
                {Object.keys(episodeAilment).map((m, i) => {
                    return (
                        <MenuItem key={i.toString()} eventKey={i + 1} onSelect={this.onSelectAilmentItem}>
                            <span className="sort-item">{episodeAilment[m]}</span>
                        </MenuItem>
                    );
                })}
            </Dropdown.Menu>
        </Dropdown>
    );

    _renderSearchBar = () => (
        <div className="episode-search-box-container no-padding">
            <input
                onChange={e => {
                    this.updateSearchBox(e);
                }}
                onKeyDown={e => {
                    this.searchEpisode(e);
                }}
                placeholder="Type in Student Name or Admission No and Press Return "
                className="episode-input-search-box"
                type="text"
                value={this.state.inSearchString || ""}
                style={{ marginLeft: 0 }}
            />
        </div>
    );

    resetFilter = () => {
        //window.location.reload()
        this.setState(
            {
                selectedClass: null,
                selectedSection: null,
                selectedAilment: null,
                inSearchString: null
            },
            () => this.fetchNewFilteredList(false)
        );
    };

    fetchNewFilteredList = flag => {
        const { selectedClass, selectedSection, selectedAilment, inSearchString } = this.state;

        const config = {
            inClass: (flag && selectedClass) || null,
            inSection: (flag && selectedSection) || null,
            inAilment: (flag && selectedAilment) || null,
            inSearchString: (flag && inSearchString) || null,
            inOffset: 0
        };

        this.props.fetchEpisodeSearch(this.props.buildEpisodeHeader(config, this.props.episodeHeader));
    };

    addNewFilter = (val, field) => {
        const newFilter = {
            [field]: val
        };
        this.setState({ ...newFilter }, () => this.fetchNewFilteredList(true));
    };

    _renderToolbar = () => {
        let { selectedClass, selectedSection, selectedAilment, dim } = this.state;
        let { classes } = this.props;

        return (
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 no-padding">
                <div className="col-xs-12 col-sm-12 col-md-7 col-lg-8 no-padding">
                    {this.props.enableSearch && (
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 no-padding">
                            {this._renderSearchBar()}
                        </div>
                    )}
                </div>
                <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 no-padding">
                    <button key={"reset"} className="btn hsg-btn-warning right" style={{paddingLeft: 3, paddingRight: 3}} onClick={() => this.resetFilter()}>
                        <span className="glyphicon glyphicon-refresh" aria-hidden="true"></span>
                    </button>
                    <div className="right no-padding" key={"section"}>
                        <DropdownButton
                            title={<text className="hsg-filter-button">{this.state.selectedSection || "Section"}</text>}
                            id="dropdown-for-section"
                            className="right"
                            onSelect={data => this.addNewFilter(data, "selectedSection")}
                        >
                            {!!selectedClass && classes[selectedClass] && classes[selectedClass].length ? (
                                classes[selectedClass].map(section =>
                                    this.state.selectedSection === section ? (
                                        <MenuItem key={section} eventKey={section} active>
                                            {section}
                                        </MenuItem>
                                    ) : (
                                        <MenuItem key={section} eventKey={section}>
                                            {section}
                                        </MenuItem>
                                    )
                                )
                            ) : (
                                <MenuItem>{"Please select a class"}</MenuItem>
                            )}
                        </DropdownButton>
                    </div>
                    <div className="right" key={"classes"}>
                        <DropdownButton
                            title={<text className="hsg-filter-button">{this.state.selectedClass || "Class"}</text>}
                            id="dropdown-for-class"
                            className="right"
                            onSelect={data => this.addNewFilter(data, "selectedClass")}
                        >
                            {Object.keys(classes).map(eachClass =>
                                this.state.selectedClass === eachClass ? (
                                    <MenuItem key={eachClass} eventKey={eachClass} active>
                                        {eachClass}
                                    </MenuItem>
                                ) : (
                                    <MenuItem key={eachClass} eventKey={eachClass}>
                                        {eachClass}
                                    </MenuItem>
                                )
                            )}
                        </DropdownButton>
                    </div>
                    <div className="right" key={"ailment"}>
                        <DropdownButton
                            title={
                                <text className="hsg-filter-button">
                                    {(this.state.selectedAilment &&
                                        getKeyByValue(episodeAilment, this.state.selectedAilment)) ||
                                        "Ailment"}
                                </text>
                            }
                            id="dropdown-for-ailment"
                            className="right"
                            onSelect={data => this.addNewFilter(episodeAilment[data], "selectedAilment")}
                        >
                            {Object.keys(episodeAilment).map(eachAilment =>
                                this.state.selectedAilment === eachAilment ? (
                                    <MenuItem key={eachAilment} eventKey={eachAilment} active>
                                        {eachAilment}
                                    </MenuItem>
                                ) : (
                                    <MenuItem key={eachAilment} eventKey={eachAilment}>
                                        {eachAilment}
                                    </MenuItem>
                                )
                            )}
                        </DropdownButton>
                    </div>
                    {/* {
                        this.props.enableEpisodeSort && (
                            <div
                                className="col-xs-1 col-sm-1 col-md-1 col-lg-1 right"
                                style={{ padding: 0, textAlign: "right" }}
                            >
                                {this._renderSortOptions()}
                            </div>
                        )
                    }
                    {
                        this.props.enableAilmentFilter && (
                            <div
                                className="col-xs-1 col-sm-1 col-md-1 col-lg-1 right"
                                style={{ padding: 0, textAlign: "right" }}
                            >
                                {this._renderAilmentOptions()}
                            </div>
                        )
                    }
                    {
                        this.props.enableClassSectionFilter && (
                            <div
                                className="col-xs-1 col-sm-1 col-md-1 col-lg-1 right"
                                style={{ padding: 0, textAlign: "right" }}
                            >
                                {this._renderAilmentOptions()}
                            </div>
                        )
                    } */}
                </div>
                {/* {this.props.enableAilment && (
                    <div
                        className="col-xs-1 col-sm-1 col-md-1 col-lg-1 right"
                        style={{ padding: 0, textAlign: "right" }}
                    >
                        {this._renderAilmentOptions()}
                    </div>
                )} */}
            </div>
        );
    };

    render() {
        let { episodeList, baseClass, episodeCardClass, pagination, episodeListPadding, showToolBar, dim } = this.props;

        return (
            <div className={baseClass}>
                {this.props.getSchoolClasses && (
                    <div className="col-md-12 col-sm-12 col-xs-12">{this._renderToolbar()}</div>
                )}

                <div className="col-md-12 col-sm-12 col-xs-12" style={{ paddingTop: episodeListPadding }}>
                    {episodeList && episodeList.length
                        ? episodeList.map((episode, index) => (
                              <div className={episodeCardClass || ""} key={index}>
                                  <EpisodeCard
                                      episode={episode}
                                      index={index}
                                      key={index}
                                      showStudentName={this.props.showStudentName}
                                      showStudentDetails={this.props.showStudentDetails}
                                      showTimePassed={true}
                                      showEpisodeId={this.props.showEpisodeId}
                                      showProfileLink={this.props.showProfileLink}
                                      isRenderedInParent={this.props.isRenderedInParent}
                                      showCustomHead={this.props.showCustomHead}
                                      episodeViewType={this.props.episodeViewType}
                                      enableSearch={this.props.enableSearch}
                                      enableSort={this.props.enableSort}
                                      openStudentProfile={studentId => this.props.openStudentProfile(studentId)}
                                      hideFullEpisode={this.props.hideFullEpisode}
                                      episodeBlockMinHeight={this.props.episodeBlockMinHeight}
                                      dim={this.props.dim}
                                      roleTypeHandler = {this.props.roleType}
                                  />
                                  {this.props.showBottomDivision && <hr />}
                              </div>
                          ))
                        : <div className="" style={{paddingTop: 50}}>
                        {this.props.noDataAvailable("Episodes are not Available!")}
                    </div>}
                </div>

                {pagination && (
                    <div className="col-md-12 col-sm-12 col-xs-12 padding-10" style={{ padding: 10, marginBottom:40 }}>
                        {this._renderPagination("hsg-dashboard-pagination-bottom right")}
                    </div>
                )}
            </div>
        );
    }
}

export default EpisodeList;



// WEBPACK FOOTER //
// ./src/Containers/SmartClinicContainerV2/Component/Episode/EpisodeList.js